// extracted by mini-css-extract-plugin
export var videoCard = "VideoCard-module--videoCard--VcvKq";
export var featuredCard = "VideoCard-module--featuredCard--PB2qc";
export var visual = "VideoCard-module--visual--hx1JR";
export var description = "VideoCard-module--description--XokEK";